export default __webpack_public_path__ + "static/media/youtube.ccfd862a.svg";